export default __webpack_public_path__ + "static/media/Venturer's Belt of the Painted Claw.e8dfd977.jpg";